import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col justify-end overflow-hidden" aria-label="首屏介绍">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20wide%20angle%20aerial%20view%20of%20densely%20packed%20Chinese%20city%20skyline%20at%20dusk%2C%20warm%20golden%20and%20amber%20sunset%20light%2C%20long%20exposure%20light%20trails%20from%20vehicles%2C%20cinematic%20editorial%20documentary%20photography%2C%20high%20contrast%20moody%20atmosphere%2C%20neutral%20earth%20tones%20and%20warm%20rust%20hues&width=1800&height=1100&seq=hero-home-bg-2026&orientation=landscape"
          alt="17爆料 - 城市纪实新闻线索平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/50 to-foreground-950/25" />
      </div>

      {/* Ticker bar at very top */}
      <div className="absolute top-16 left-0 w-full bg-primary-500/90 backdrop-blur-sm py-1.5 z-10 overflow-hidden">
        <div className="ticker-wrap flex items-center">
          <span className="flex-shrink-0 px-4 text-xs font-bold text-background-50 uppercase tracking-widest border-r border-primary-400 mr-4">
            最新核实
          </span>
          <div className="ticker-track text-xs text-background-50/90 gap-10">
            <span className="mr-10">· 连锁蛋糕店使用过期奶油，监管介入停业整改</span>
            <span className="mr-10">· 小区物业违规收取装修押金125万元，业主集体维权</span>
            <span className="mr-10">· 网络刷单「锁仓」诈骗新模式，58名受骗者提供线索</span>
            <span className="mr-10">· 充电桩运营商暗升价格，消费者维权获响应</span>
            <span className="mr-10">· 连锁蛋糕店使用过期奶油，监管介入停业整改</span>
            <span className="mr-10">· 小区物业违规收取装修押金125万元，业主集体维权</span>
            <span className="mr-10">· 网络刷单「锁仓」诈骗新模式，58名受骗者提供线索</span>
            <span className="mr-10">· 充电桩运营商暗升价格，消费者维权获响应</span>
          </div>
        </div>
      </div>

      {/* Hero content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-6 pb-16 md:pb-24">
        <div className="max-w-3xl">
          <span className="inline-block px-3 py-1 text-xs font-semibold uppercase tracking-widest bg-primary-500 text-background-50 rounded mb-5">
            线索征集 · 核实发布
          </span>
          <h1 className="font-heading text-4xl md:text-6xl font-black text-background-50 leading-tight mb-4">
            你有料，<br />
            <span className="text-primary-400">我们来核实</span>
          </h1>
          <p className="text-base md:text-lg text-background-200 leading-relaxed max-w-xl mb-8">
            17爆料是专业的新闻线索征集与核实发布平台。无论是消费维权、社会民生还是行业黑料，只要你有真实线索，通过<strong className="text-background-50">17爆料投稿</strong>或<strong className="text-background-50">17爆料私信</strong>，经编辑部核实后我们会第一时间发布，让真相被更多人看到。
          </p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/submit"
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-md transition-colors whitespace-nowrap text-sm"
            >
              <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                <i className="ri-send-plane-fill" />
              </span>
              立即投稿 / 私信
            </Link>
            <Link
              to="/reports"
              className="px-6 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-semibold rounded-md transition-colors border border-background-50/30 whitespace-nowrap text-sm backdrop-blur-sm"
            >
              <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                <i className="ri-article-line" />
              </span>
              浏览已核实报道
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-6 mt-10 pt-8 border-t border-background-50/20">
            {[
              { num: '4,200+', label: '收到线索' },
              { num: '380+', label: '核实发布' },
              { num: '96%', label: '线索保密率' },
              { num: '8', label: '报道栏目' },
            ].map((s) => (
              <div key={s.label}>
                <p className="font-heading text-2xl font-bold text-primary-400">{s.num}</p>
                <p className="text-xs text-background-400 mt-0.5">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}